<template>
  <v-layout hidden-sm-and-down>
    <v-flex lg7>
      <v-list-item-title
        class="headline mb-1 title font-weight-bold environment-title"
      >
        <a
          :href="'http://' + fqdn"
          target="_blank"
          :class="{ disabled: status !== 'running', 'disabled-btn': environment.ConnectedId}"
        >
          {{ name }}
          <v-icon
            v-if="status == 'running' && !environment.ConnectedId"
            class="title-icon"
            right
            id="icon-style-pink"
            >fas fa-external-link-alt</v-icon
          >
        </a>
      </v-list-item-title>
    </v-flex>

    <v-flex lg5 text-right>
      <!-- {{ status = "FAILED_DURING_SERVICE_CREATE" }} -->
      <!-- {{ status = "SERVICE_CREATE" }} -->
      <span
        v-if="
          status === 'running' || status === 'pending' || status === 'stopped'
        "
        class="status my-auto"
        >{{ templateSnapshotStatus() }} {{ status }}</span
      >

      <v-btn
        id="stop-btn-style"
        v-if="status == 'running' || status == 'pending'"
        @click="onStopEnvironment(id)"
        :class="{ 'disabled-btn': loading }"
      >
        <v-icon small left v-if="!loading">fas fa-stop</v-icon>
        <v-icon small left v-else>fas fa-spinner fa-spin</v-icon>STOP
      </v-btn>

      <v-btn
        id="run-btn-style"
        v-else-if="status == 'stopped'"
        @click="onStartEnvironment(id)"
        :disabled="templateStatus === 'pending' || snapshotStatus === 'pending'"
        :class="{ 'disabled-btn': loading }"
      >
        <v-icon small left v-if="!loading">fas fa-play</v-icon>
        <v-icon small left v-else>fas fa-spinner fa-spin</v-icon>START
      </v-btn>

      <v-chip
        outlined
        color="red"
        v-else-if="status.toLowerCase().includes('failed')"
      >
        <v-avatar left> <v-icon>fas fa-exclamation</v-icon> </v-avatar>ERROR
      </v-chip>

      <!-- <v-btn
        id="run-btn-style"
        class="during-action-btn-style disabled-btn"
        v-if="status.toLowerCase().includes('pending') || status.toLowerCase().includes('create') || status.toLowerCase().includes('starting')"
      >
        <v-icon small class="mr-1">fas fa-spinner fa-spin</v-icon>STARTING
      </v-btn> -->

      <!-- <v-btn
        class="during-action-btn-style disabled-btn"
        id="run-btn-style"
        v-if="status.toLowerCase() === 'during_stopping'"
      >
        <v-icon small class="mr-1">fas fa-spinner fa-spin</v-icon>STOPPING
      </v-btn> -->

      <!-- <v-btn class="during-action-btn-style disabled-btn" id="run-btn-style" v-else-if="status.toLowerCase() === 'during_restore'">
        <v-icon small class="mr-1">fas fa-spinner fa-spin</v-icon>
         RESTORING
      </v-btn> -->

      <v-chip
        outlined
        color="purple"
        v-else-if="status.toLowerCase() === 'during_restore'"
      >
        <v-avatar left>
          <v-icon>fas fa-spinner fa-spin</v-icon>
        </v-avatar>
        RESTORING
      </v-chip>

      <v-chip
        outlined
        color="purple"
        v-else-if="
          status.toLowerCase() === 'pending' ||
          status.toLowerCase().includes('create') ||
          status.toLowerCase().includes('starting')
        "
      >
        <v-avatar left>
          <v-icon>fas fa-spinner fa-spin</v-icon>
        </v-avatar>
        STARTING
      </v-chip>

      <v-chip
        outlined
        color="purple"
        v-else-if="status.toLowerCase().includes('stopping')"
      >
        <v-avatar left>
          <v-icon>fas fa-spinner fa-spin</v-icon>
        </v-avatar>
        STOPPING
      </v-chip>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
    };
  },
  props: [
    "id",
    "name",
    "status",
    "fqdn",
    "templateStatus",
    "snapshotStatus",
    "environment",
  ],
  methods: {
    ...mapActions([
      "stopEnvironment",
      "startEnvironment",
      "startConnectedEnvironment",
      "stopConnectedEnvironment",
      "getEnvironments",
      "getConnectedEnvironments",
    ]),
    async onStopEnvironment(id) {
      this.disabledButton = true;
      this.loading = true;

      if (this.environment.ConnectedId) {
        const data = {
          connectedEnvId: this.environment.ConnectedId,
        };
        await this.stopConnectedEnvironment(data);
        await this.getConnectedEnvironments();
      } else {
        const data = {
          environmentId: id,
        };
        await this.stopEnvironment(data);
        await this.getEnvironments();
      }

      this.loading = false;
      this.disabledButton = false;
      this.$emit("statusChange");
    },
    async onStartEnvironment(id) {
      this.loading = true;

      if (this.environment.ConnectedId) {
        const data = {
          connectedEnvId: this.environment.ConnectedId,
        };
        await this.startConnectedEnvironment(data);
        await this.getConnectedEnvironments();
      } else {
        const data = {
          environmentId: id,
        };
        await this.startEnvironment(data);
        await this.getEnvironments();
      }

      this.loading = false;
      this.$emit("statusChange");
    },
    templateSnapshotStatus() {
      const { templateStatus, snapshotStatus } = this;

      if (templateStatus === "pending") {
        return "creating a template /";
      }

      if (snapshotStatus === "pending") {
        return "creating a snapshot /";
      }
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #000 !important;
}

.disabled {
  pointer-events: none;
  cursor: default;
  color: grey !important;
}

.disabled-btn {
  pointer-events: none;
}

.stopping-btn-style {
  background-color: #cb2536 !important;
}

.during-action-btn-style {
  background-color: #f3d526 !important;
}
</style>